import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import 'animate.css';
import './App.scss';

import { AppRoutes } from './routes';
import { PageTitleUpdater } from './shared/components';
import { fontAwesomeIcons, i18n } from './shared/settings';
import { i18nGtmTracking } from './shared/settings/i18nGtmTracking';

fontAwesomeIcons.setup();
i18nGtmTracking.init();

function App() {
	return (
		<I18nextProvider i18n={i18n}>
			<PageTitleUpdater />
			<BrowserRouter>
				<AppRoutes />
			</BrowserRouter>
		</I18nextProvider>
	);
}

export default App;
